import { SIZES } from './constants'
import objectAssign from 'object-assign'

let detections
let watching = false
export default function detection () {
  const targetWindow = window
  if (typeof targetWindow.matchMedia !== 'function') {
    return console.error('Browser does not support matchMedia')
  }
  if (!detections) {
    detections = Object.keys(SIZES).reduce((detections, deviceType) => {
      const query = SIZES[deviceType].map(toQuery).filter(Boolean).join(' and ')
      const mediaQueryList = targetWindow.matchMedia(query)
      return objectAssign({}, detections, { [deviceType]: mediaQueryList })
    }, {})
  }
  return detections
}

export function viewportDetection () {
  if (!watching) {
    watching = true
    const targetWindow = window
    const detections = detection()
    Object.keys(detections).forEach(deviceType => {
      const updater = updateMatches(targetWindow, deviceType)
      const mediaQueryList = detections[deviceType]
      mediaQueryList.addListener(updater)
      updater.call(mediaQueryList)
    })
  }
}

function updateMatches (targetWindow, deviceType) {
  return function (e) {
    const target = e || this
    const className = 'zb-is-viewport-' + deviceType
    const documentElement = targetWindow.document.documentElement
    documentElement.className = getUpdatedClasses(
      (documentElement.className || '').split(/\s+/),
      className,
      target.matches
    )
      .filter(String)
      .join(' ')
  }
}

function getUpdatedClasses (classList, className, matches) {
  return matches
    ? classList.concat(className)
    : classList.filter(c => c !== className)
}

function toQuery (size, index) {
  return size ? `(${index ? 'max' : 'min'}-width: ${size}px)` : size
}
